import { appForceLogout, appSetLoading, appSetSendingRequest, clearStorage } from "../store/actions/appAction";
import { apiSetAlert } from "../api/appApi";
import momentJalaali from "moment-jalaali";
import { store } from "../store/store";
import axios from "../axios/axios";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";

export const formatNumber = (number) => {
    return number.toString().replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
};

export const formatMobile = (mobile) => {
    return mobile
        .toString()
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        .slice(0, 11);
};

export function formatPrice(num) {
    if (num) {
        let negative = num < 0;
        let price = 0;
        let number = num.toString().replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
        // number = number.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
        number = number.toString().replaceAll(",", "");

        if (number && number.length) {
            const parts = number.split(".");
            price = ((negative ? -1 : 1) * parseInt(parts[0].replace(/[^\d.]/g, ""))).toLocaleString();
            if (parts[1] !== undefined) {
                const float = parts[1]
                    .toString()
                    .replace(/[^\d.]/g, "")
                    .substring(0, 3);
                price = `${price}.${float ?? "00"}`;
            }
        }

        return price === "NaN" ? 0 : price;
    }
    return 0;
}

export const S2N = (value) => {
    let number = value.toString().replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    number = number?.toString().replaceAll(",", "") || "";
    return number;
};

export function formatDate(inputValue, parseGregorian = false, isJalali = false, format) {
    if (!parseGregorian) {
        const state = store.getState();
        const calendar = state?.businessReducer?.business?.business?.calendar;
        parseGregorian = calendar && calendar === "میلادی";
    }

    if (!inputValue) return "";
    if (!inputValue.locale) {
        if (isJalali) {
            inputValue = momentJalaali(inputValue, format ?? "jYYYY/jM/jD");
        } else {
            inputValue = momentJalaali(inputValue, format ?? "YYYY/M/D");
        }
    }
    const inputFormat = format ?? (!parseGregorian ? "jYYYY/jM/jD" : "YYYY/M/D");
    return inputValue.locale(isJalali ? "fa" : "en").format(inputFormat);
}

export function formatPersianDate(date) {
    const persianDate = momentJalaali(date).format("jYYYY/jM/jD");
    return persianDate;
}

export function validateMobile(mobile) {
    const regex =
        /(0|\+98)?([ ]|,|-|[()]){0,2}9[0|1|2|3|4|9]([ ]|,|-|[()]){0,2}(?:[0-9]([ ]|,|-|[()]){0,2}){8}/;
    return regex.test(mobile);
}

export function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
}

export function resetAppData(dispatch) {
    dispatch(clearStorage());
    // dispatch(setUser(null))
    // dispatch(setToken(null))
    // dispatch(setBusiness(null))
    // dispatch(setBusinesses([]))
}

export function setSelectItemLabels(data, valueTitle, labelTitle) {
    // data type should be array or object
    if (data && (Array.isArray(data) || typeof data === "object")) {
        if (Array.isArray(data) && data.length > 0) {
            return data.map(
                (x) =>
                    x && {
                        ...x,
                        label:
                            typeof labelTitle === "function"
                                ? labelTitle(x)
                                : x.accountingCode
                                    ? `${x.accountingCode} - ${x[labelTitle]}`
                                    : x[labelTitle],
                        value: x[valueTitle],
                    }
            );
        } else {
            data.label = typeof labelTitle === "function" ? labelTitle(data) : data[labelTitle];
            data.value = data[valueTitle];

            return data;
        }
    } else {
        return undefined;
    }
}

export function errorDispatcher(error, dispatch, showAlert = true) {
    if (showAlert && error.response && error.response.data.message && error.response.status !== 500 && error.response.status !== 401) {
        dispatch(apiSetAlert(error.response.data.message, "error"));
    } else if (showAlert && error.response && error.response.data.message && error.response.status == 401) {
        dispatch(apiSetAlert(error.response.data.message, "error"));
        dispatch(appForceLogout())
        dispatch(resetAppData(dispatch))

    }
    dispatch(appSetLoading(false));
    dispatch(appSetSendingRequest(false));
}

export function lowerFirst(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

export function getDefaultCurrency(defaultCurrencyId, currencies) {
    const curr = store.getState().currencyReducer.currencies
    return curr.find((c) => c.id === defaultCurrencyId);
}

export function getOptionsQuery(pagination, search, sort) {
    let options = search?.filterParams ?? {};
    if (pagination) {
        options.limit = pagination.limit;
        options.page = pagination.page > 0 ? pagination.page : 1;
    }

    if (sort) {
        options.key = sort.key;
        options.dir = sort.dir;
        options.sortParams = sort.sortParams;
    }
    if (search && Object.keys(search).length > 0) {
        options.primarySearch = search.primarySearch;
        options.secondarySearch = search.secondarySearch;
        options.columnType=search.columnType
        options.filterType = search?.filterType?.toString();
        options.column=search.column
    }

    if (pagination?.filters && Array.isArray(pagination?.filters) && pagination?.filters?.length) {
        options.filters = pagination?.filters
    }

    return options;
}

export function search(text, data, categoryId = null) {
    if (!data || !Array.isArray(data)) return [];
    if ((!text || text === "") && !categoryId) return data

    if (text && text.length) {
        const texts = text.split(" ");
        data = data.filter((x) => {
            let flag = true;
            texts.map((t) => {
                if (!`${x.label} ${x.dsc}`.toLowerCase().includes(t.toLowerCase())) {
                    flag = false;
                }
            });
            return flag;
        });
    }

    if (categoryId) {
        data = data.filter((x) => {
            if (x.categoryId)
                return x.CategoryId === categoryId
            if (x.Category) {
                return x.Category.id === categoryId
            }
        });
    }

    return data
}

export function bytesToKb(bytes) {
    return (bytes / 1024).toFixed(2)
}

export function openArchiveUrl(item) {
    // const { REACT_APP_BASE_URL_LOCAL, REACT_APP_BASE_URL } = process.env;
    // const _url = REACT_APP_BASE_URL ? REACT_APP_BASE_URL : "https://api.chortke.app/v2/" + item.url + `?token=${item.token}`;
    // window.open(_url, "_blank");
    const { getState, dispatch } = store
    const token = getState().businessReducer.business?.token;
    const url = item.url + `?token=${item.token}`;
    dispatch(appSetLoading());
    axios
        .get(url, {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
        })
        .then((response) => {
            dispatch(appSetLoading(false));
            const now = DateToString(Date.now()).replace("/", "_")
            const fileName = item.fileName;
            fileDownload(response.data, `${fileName}`);
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
}